import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import pageWithReduxAndIntl from '../app/hoc/PageWithReduxAndIntl';
import { Error } from '../app/Error/components';
import RavenUtils from '../app/utils/raven';
import { fetchSuggestionsRequest } from '../app/Suggestions/actions';

class ErrorPage extends React.Component {
  static async getInitialProps({ req, res, jsonPageRes, err, store }) {
    const statusCode = res ? res.statusCode : jsonPageRes ? jsonPageRes.status : null; // eslint-disable-line no-nested-ternary
    const configState = store.getState().config;
    const config = {
      release: get(configState, ['env', 'version']),
      environment: get(configState, ['env', 'environment']),
      appEnvironment: get(configState, ['env', 'appEnvironment']),
      hostname: get(configState, ['env', 'hostname']),
      domain: get(configState, ['env', 'domain']),
    };

    if (err) {
      const isServerSide = typeof req !== 'undefined';
      const key = isServerSide
        ? get(configState, ['client', 'sentryPrivateKey'])
        : get(configState, ['client', 'sentryPublicKey']);

      RavenUtils.reportError(err, key, config, { extra: req });
    }

    return { statusCode };
  }

  static async runInitialSagas({ store, res }) {
    if (res.statusCode === 404) {
      store.dispatch(fetchSuggestionsRequest());
    }
  }

  render() {
    const { statusCode, routeName } = this.props;
    return <Error statusCode={statusCode} routeName={routeName} />;
  }
}

ErrorPage.defaultProps = {
  statusCode: 0,
  routeName: null,
};

ErrorPage.propTypes = {
  statusCode: PropTypes.number,
  routeName: PropTypes.string,
};

export default pageWithReduxAndIntl(ErrorPage);



// WEBPACK FOOTER //
// ./pages/_error.js